import { ActionTypes } from '../../constants/ActionTypes';
import { ILetterForderItem } from '../../interfaces/Folder';

export const onGetLetterFolderList = (searchText: string | undefined) => {
  return {
    type: ActionTypes.GET_LETTERFOLDER_LIST,
    payload: searchText,
  };
};

export const fetchLetterFolderListSuccess = (
  letterFolderList: ILetterForderItem[],
) => {
  return {
    type: ActionTypes.FETCH_LETTERFOLDER_LIST_SUCCESS,
    payload: letterFolderList,
  };
};
